module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/kettle-e672e7fb5239134d2dd8030a3ef9d316.svg";